module.exports = __webpack_public_path__ + "static/media/genefirst.3b8fc2eb.png";